import { ActionReducerMap } from '@ngrx/store';

import * as authStore from '../auth/store';
import * as traduzioniStore from '../traduzioni/store';
import * as allegatiStore from '../allegati/store';
import * as utentiStore from '../utenti/store';
import * as glossariStore from '../glossari/store';
import * as ricercaStore from '../ricerca/store';
import * as undoRedoStore from '../undoredo/store';

/**Interfaccia dello stato dell'applicazione che accentra gli stati dei diversi store */
export interface AppState {
    /**Stato a livello dell'autenticazione */
    auth: authStore.State;
    /**Stato a livello delle traduzioni */
    traduzioni: traduzioniStore.State;
    /**Stato a livello degli allegati */
    allegati: allegatiStore.State;
    /**Stato a livello degli utenti */
    utenti: utentiStore.State;
    /**Stato a livello dei glossari */
    glossari: glossariStore.State;
    /**Stato a livello della ricerca avanzata */
    ricerca: ricercaStore.State;
    undoredo: undoRedoStore.StateHistory;
}

/** Stato iniziale a livello di applicazione, accentra i diversi stati iniziali dei singoli store */
export const initialState: AppState = {
    auth: authStore.initialState,
    traduzioni: traduzioniStore.initialState,
    allegati: allegatiStore.initialState,
    utenti: utentiStore.initialState,
    glossari: glossariStore.initialState,
    ricerca: ricercaStore.initialState,
    undoredo: undoRedoStore.initialStateHistory
};

/** Reducer a livello di applicazione, accentra i reducer dei singoli store */
export const reducers: ActionReducerMap<AppState> = {
    auth: authStore.authReducer,
    traduzioni: traduzioniStore.traduzioniReducer,
    allegati: allegatiStore.allegatiReducer,
    utenti: utentiStore.utentiReducer,
    glossari: glossariStore.glossariReducer,
    ricerca: ricercaStore.ricercaReducer,
    undoredo: undoRedoStore.undoRedoReducer
};

export const effects: Array<any> = [
    authStore.AuthEffects,
    utentiStore.UtentiEffects,
    glossariStore.GlossariEffects,
    ricercaStore.RicercaEffects,
    undoRedoStore.UndoRedoEffects
];

/**Stato della parte di autenticazione */
export const getMyAuth = (s: AppState) => s.auth;
/**Stato della parte di traduzione */
export const getMyTraduzioni = (s: AppState) => s.traduzioni;
/**Stato della parte di allegati */
export const getMyAllegati = (s: AppState) => s.allegati;
/**Stato della parte di utenti */
export const getMyUtenti = (s: AppState) => s.utenti;
/**Stato della parte di glossari */
export const getMyGlossari = (s: AppState) => s.glossari;
/**Stato della parte di ricerca avanzata */
export const getMyRicerca = (s: AppState) => s.ricerca;

export const getMyUndoRedo = (s: AppState) => s.undoredo;